import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartPickupLocationBlockConfig } from '@front-platform/content-builder';
import { cartPickupLocationBlockResolveConfig } from '@front-platform/content-builder';
import { map } from 'rxjs/operators';
import { Component, input } from '@angular/core';

import { DoodOrderModel } from '@store/order/order.model';
import { OrderStoreSelector } from '@common/selectors/order.selector';
export interface CartPickupLocationBlockRuntimeConfig {}

export type CartPickupLocationBlockConfigInput = Partial<
  Omit<CartPickupLocationBlockConfig, keyof CartPickupLocationBlockRuntimeConfig> &
    CartPickupLocationBlockRuntimeConfig
>;
export type CartPickupLocationBlockResolvedConfig = Omit<
  CartPickupLocationBlockConfig,
  keyof CartPickupLocationBlockRuntimeConfig
> &
  Partial<CartPickupLocationBlockRuntimeConfig>;
export interface CartPickupLocationBlockContract extends ConfigComponentContract<
  CartPickupLocationBlockConfigInput,
  CartPickupLocationBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-pickup-location-block',
  templateUrl: './cart-pickup-location-block.component.html',
  standalone: false,
})
export class CartPickupLocationBlockComponent implements CartPickupLocationBlockContract {
  readonly config = input<CartPickupLocationBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartPickupLocationBlockConfig,
    CartPickupLocationBlockRuntimeConfig
  >(cartPickupLocationBlockResolveConfig, () => ({ config: this.config() }));
  orderPickupLocation$ = this.orderSelector.selectValidation$.pipe(
    map(order => (order as unknown as DoodOrderModel)?.pickup_location),
  );

  constructor(private orderSelector: OrderStoreSelector) {}
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartPickupLocationBlockComponent, {
  'keyAliases': {},
});
